module.exports = __webpack_public_path__ + "img/donante-ceinre.08c55602.png";